export function beforeSave(record) {
  const newRecord = { ...record };
  newRecord.form = record.form.id;
  return newRecord;
}
